import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { minNumberValidator } from 'src/app/core/validators/min-number-validator';
import { CreateUserSafeIPsCommand } from '../../../../../core/api/models/create-user-safe-i-ps-command';
import { UserSafeIPsService } from '../../../../../core/api/services/user-safe-i-ps.service';
import { RegularExpressions } from '../../../../../core/constants/regular-expressions';
import { BaseFormPageComponent } from '../../../../shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { ModalTitleComponent } from "../../../../../shared/global/modal-title/modal-title.component";

@Component({
    selector: 'app-safe-ips-form',
    templateUrl: './safe-ips-form.component.html',
    imports: [BaseFormModule, ModalTitleComponent]
})
export class SafeIpsFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  protected currentService = inject(UserSafeIPsService);
  model: CreateUserSafeIPsCommand = {};
  isIpRange: boolean = false;
  ip: string = '';
  rangeIp: string;
  isShowAlertDetails: boolean = false;
  ipLastDigit: any;
  //#endregion

  constructor(
    private dialogRef: MatDialogRef<SafeIpsFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient
  ) {
    super();
    this.formPageConfig.title = data?.title;
    this.formPageConfig.isEditMode = data?.isEdit;
    if (data.model) this.model = data.model;
  }

  ngOnInit() {
    this.initForm();
    this.initModel();
  }

  initModel(): void {
    this.model.useToCreateToken = false;
    this.model.useToLoginPanel = false;
  }

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }

  initForm() {
    this.form = new FormGroup({
      ipAddress: new FormControl('', [
        Validators.required,
        Validators.pattern(RegularExpressions.ip),
      ]),
      ip: new FormControl(''),

      rangeIp: new FormControl(''),
      isIpRange: new FormControl(''),

      useToCreateToken: new FormControl(''),
      useToLoginPanel: new FormControl(''),
      description: new FormControl(''),
    });
  }

  changeValidators(isRangeIp) {
    if (isRangeIp) {
      this.form.get('ipAddress').clearValidators();
      this.form
        .get('ip')
        .setValidators([
          Validators.required,
          Validators.pattern(RegularExpressions.ip),
        ]);
      this.form
        .get('rangeIp')
        .setValidators([
          Validators.required,
          Validators.min(1),
          minNumberValidator(this.ipLastDigit),
          Validators.max(254),
        ]);
    } else {
      this.form.get('ip').clearValidators();
      this.form.get('rangeIp').clearValidators();
      this.form
        .get('ipAddress')
        .setValidators([
          Validators.required,
          Validators.pattern(RegularExpressions.ip),
        ]);
    }
    this.form.get('ip').updateValueAndValidity();
    this.form.get('ipAddress').updateValueAndValidity();
  }

  //#region Api

  //Create
  baseCreateApi(model: CreateUserSafeIPsCommand) {
    this.unSubs();

    this.loading = true;

    if (this.isIpRange) model.ipAddress = this.ip + '|' + this.rangeIp;

    this.currentService
      .userSafeIPsCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#region final methods

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close(true);
    this.unSubs();
  }

  //#endregion

  changeIsRangeIp(isRange) {
    if (isRange.checked) this.isShowAlertDetails = false;

    this.changeValidators(isRange.checked);
  }

  //todo fix Access-Control-Allow-Origin error
  getCurrentIp() {
    this.http.get('http://api.ipify.org/?format=json').subscribe((res: any) => {
      if (this.isIpRange) this.ip = res.ip;
      else this.model.ipAddress = res.ip;
    });
  }

  onChangeAlertDetails(event) {
    const timeOut = setTimeout(() => {
      this.isShowAlertDetails = event.hasAttribute('open');
      clearTimeout(timeOut);
    }, 20);
  }

  getIpLastDigit() {
    this.ipLastDigit = this.ip.slice(-1);
    this.changeValidators(this.isIpRange);
  }
}
